import { generatePath } from 'react-router-dom'
import { BLAZE_HOME_PATH } from 'paths'
import { Workspace } from 'types'
import { Home } from 'blaze-ui/icons'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { HomeFilled } from 'blaze-ui/icons/20'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Home2 } from 'blaze-ui/icons/24'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuHomeItem = ({ workspace, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <NavMenuItem
      icon={isSystemRedesignEnabled ? Home2 : Home}
      activeIcon={isSystemRedesignEnabled ? Home2 : HomeFilled}
      to={generatePath(BLAZE_HOME_PATH, { workspaceId: workspace.id })}
      onPress={onPress}
      label="Home"
    />
  )
}

export { NavMenuHomeItem }
